<template>
    <div class="content-1">
        <div class="title-banner">
            <img class="title-banner-img" src="../../../assets/images/csr_banner_01.jpg" alt="csr_banner_01"/>
            <img class="title-banner-img-mobile" src="../../../assets/images/csr_banner_01.jpg" alt="csr_banner_mobile"/>
<!--            <div class="title-box">-->
<!--                <h2 class="csr-title AvantGarde">-->
<!--                    SUSTAINABLE DEVELOPMENT-->
<!--                </h2>-->
<!--                <h3 class="csr-title-cn YaSiRegular">可持续发展</h3>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CsrContent1'
    }
</script>

<style lang="scss" scoped>
    @use 'styles/varibles' as *;
    @use 'styles/common' as *;
    .content-1 {
        margin-bottom: 5vw;
    }
    .title-banner {
        margin: 10rem 0 0 0;
        position: relative;
        opacity: 0;
    }
    .title-box {
        position: absolute;
        left: 3%;
        bottom: 8%;
        color: #fff;
    }
    .csr-title {
        opacity: 0;
    }
    .csr-title-cn {
        letter-spacing: .5rem;
        opacity: 0;
    }
    .title-banner-img {
        width: 100%;
    }
    .title-banner-img-mobile {
        display: none;
        width: 100%;
    }
    .content-1-list {
        margin: 0 0 70px 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    .content-1-list li {
        margin-top: 70px;
        display: flex;
        width: 45%;
    }
    .content-1-inner {
        margin-left: 20px;
        width: 80%;
    }
    .content-1-img-box {
        width: 15%;
    }
    .content-1-img {
        width: 100%;
    }
    .content-1-h3 {
        margin-bottom: 10px;
    }
    .content-1-p {
        font-size: 12px;
        @include textJustify;
    }
    @for $i from 1 through 6
    {
        .a#{$i}
        {
            opacity: 0;
        }
    }
    .animate .title-banner {
        animation: opacityIn .5s linear forwards;
    }
    .animate .csr-title {
        animation: fadeInUp .5s .5s linear forwards;
    }
    .animate .csr-title-cn {
        animation: fadeInUp .5s .7s linear forwards;
    }
    @for $i from 1 through 6
    {
        .animate .a#{$i}
        {
            animation: opacityIn 1s #{700 + 200 * $i}ms linear forwards;
        }
    }
    @media screen and (max-width: 750px) {
        .content-1-list {
            display: block;
        }
        .content-1-list li {
            width: auto;
        }
        .title-banner-img {
            display: none;
        }
        .title-banner-img-mobile {
            display: block;
        }
    }
    @media screen and (max-width: 500px) {
        .title-box {
            left: 8%;
            bottom: 10%;
        }
        .title-banner {
            margin: 3rem 0 0 0;
        }
        .content-1-list {
            margin: 0 0 50px 0;
        }
        .content-1-list li {
            margin-top: 50px;
        }
    }
</style>
